import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { JobPortalService } from 'src/app/services/job-portal.service';

@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.css']
})
export class AddLocationComponent implements OnInit {

 
  locationForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private job_portal_service: JobPortalService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.locationForm = this.fb.group({
      description: [''],
      isActive: [true],
      country: [''],
      city: [''],
      provinceOrState: [''],
      postalCode: [''],
    })
  }

  addLocation(){
    this.formSubmit = true;
    if(!this.locationForm.valid){
      return
    }
    let body = {

      "version": 0,
      "isActive": this.locationForm.get('isActive').value,
      "description": this.locationForm.get('description').value,
      "id": "",
      "locationId": 0,
      "country": this.locationForm.get('country').value,
      "city": this.locationForm.get('city').value,
      "provinceOrState": this.locationForm.get('provinceOrState').value,
      "postalCode": this.locationForm.get('postalCode').value,
      "cid": this.cid,
    }

    console.log(body)
    this.job_portal_service.addLocation(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.locationForm.reset()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

}

